"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCampaigns = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getCampaigns(_a) {
    var where = _a.where;
    var variables = {
        where: where,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query($where: CampaignWhereInput) {\n        campaigns(where: $where) {\n          id\n          type\n          price\n          isActive\n          validForDays\n          description\n          createdAt\n          updatedAt\n        }\n      }\n    "], ["\n      query($where: CampaignWhereInput) {\n        campaigns(where: $where) {\n          id\n          type\n          price\n          isActive\n          validForDays\n          description\n          createdAt\n          updatedAt\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getCampaigns = getCampaigns;
var templateObject_1;
